import React, { useContext, useState, Component } from "react";
import styled from "styled-components";

import ListView from "./list-view";
import OptionsOnAll from "./options-on-all";

import { Col } from "../../comps";

const Wrapper = styled(Col)`
  width: 100%;
  align-items: center;
  padding-left: 30px;
  padding-right: 30px;
`;

const ResultWrapper = styled(Col)`
  flex-grow: 1;
  width: 100%;
  margin-bottom: 70px;
  margin-top: 20px;
`;

export default ({ list, modalData, actions }) => {
  const { items, text } = list;

  return (
    <Wrapper>
      <OptionsOnAll
        items={items}
        text={text}
        modalData={modalData}
        actions={actions}
      />
      <ResultWrapper>
        {items && (
          <ListView
            items={items}
            modalData={modalData}
            actions={actions}
            time={new Date().getTime()}
          />
        )}
      </ResultWrapper>
    </Wrapper>
  );
};
